// extracted by mini-css-extract-plugin
export var integrationButton = "_8u-0";